import cartReducer from "../Cart/cartReducer";

const cartMiddleware = (store) => (next) => (action) => {
	const upcomingState = [action].reduce(cartReducer, store.getState());
    const invalid = upcomingState.filter(state => state.quantity < 0)

    if(invalid.length === 0) {
        next(action);
    }
};

export default cartMiddleware;